(function () {
  var bar = document.querySelector('[data-ink-sticky-cart]');
  if (!bar) return;

  var realButton = document.querySelector('.product-form__submit');
  if (!realButton) return;

  var priceSlot = bar.querySelector('[data-ink-sticky-cart-price]');
  var proxyButton = bar.querySelector('[data-ink-sticky-cart-button]');
  var proxyLabel = bar.querySelector('[data-ink-sticky-cart-button-label]');
  var realPriceContainer = document.querySelector('[id^="price-"]');

  function syncPrice() {
    if (!realPriceContainer || !priceSlot) return;
    var current = realPriceContainer.querySelector('.price-item--sale, .price-item--regular:not(s)');
    priceSlot.textContent = current ? current.textContent.trim() : '';
  }

  function syncButtonState() {
    proxyButton.disabled = realButton.disabled;
    if (proxyLabel) {
      proxyLabel.textContent = realButton.textContent.trim();
    }
  }

  proxyButton.addEventListener('click', function () {
    realButton.click();
  });

  if (realPriceContainer && window.MutationObserver) {
    new MutationObserver(syncPrice).observe(realPriceContainer, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (window.MutationObserver) {
    new MutationObserver(syncButtonState).observe(realButton, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
    });
  }

  if (window.IntersectionObserver) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('ink-sticky-cart--visible', !entry.isIntersecting);
          bar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );
    observer.observe(realButton);
  }

  syncPrice();
  syncButtonState();
})();
